import React from 'react';
import { Grid } from '@mui/material';
import { colors } from '../../utils/theme';
import { RootineMediaAndText } from '../../atoms/RootineMediaAndText';
import { ReviewContent } from '../../atoms/ReviewContent';
import { RootineCarousel } from '../../atoms/RootineCarousel';

const reviews = [
  {
    rating: 5,
    review: `I feel spectacular since beginning my Routine regimen and couldn't be more pleased with my overall health. The science behind the Rootine product places the company in a category all by itself. I have tried many other products in the past (the list could go on and on) but they were not tailored to my needs. Rootine blows the competition out of the water. Thank you.`,
    author: {
      name: 'Ryan Rhoades',
      title: '',
    },
    mediaSrc: '',
  },
  {
    rating: 5,
    review: `My hair and nails are much better . I’ve noticed my skin is too . Plus I feel that my body absorbs the vitamins and minerals much more easily. Taking tablets would upset my stomach. These tiny spheres never do that`,
    author: {
      name: 'Michele Cappellett',
      title: '',
    },
    mediaSrc: '',
  },
  {
    rating: 5,
    review: `I would take 5-6 different supplements per day, from shakes to capsules. Having a targeted solution engineered for my body based on my personal genetic and lab results takes a lot of the guess work out of which supplements to take and at what quantity. I also love that the delivery mechanism is easily absorbed by the body.`,
    author: {
      name: 'Jared Schlegel',
      title: '',
    },
    mediaSrc: '',
  },
];

export const UserReviewsSection = (): JSX.Element => {
  return (
    <Grid
      sx={{
        pt: 12,
        pb: 24,
        px: 3,
        borderBottom: `1px solid ${colors.greys.BORDER_GREY}`,
      }}
    >
      <RootineCarousel
        boxStyle={{ mt: -10, px: 7 }}
        activeDotColor={colors.greys.BASE_WHITE}
      >
        {reviews.map((review, index: number) => (
          <RootineMediaAndText
            textComponent={<ReviewContent review={review} />}
            mediaSrc={review.mediaSrc}
            key={`review-${index}`}
          />
        ))}
      </RootineCarousel>
    </Grid>
  );
};
